import { progressiveComponent } from 'site-modules/shared/components/progressive-component/progressive-component';
import { RenderOnInteraction } from 'site-modules/shared/components/render-on-interaction/render-on-interaction';
import { OdometerWrapperSeo } from './odometer-wrapper-seo';

export const OdometerWrapperProgressive = progressiveComponent({
  SEOComponent: OdometerWrapperSeo,
  fullComponent: {
    loader: () => import(/* webpackChunkName: "odometer-wrapper" */ './odometer-wrapper'),
    name: 'OdometerWrapper',
  },
  Renderer: RenderOnInteraction,
  interactionEvents: ['keydown', 'scroll', 'mousedown', 'touchstart', 'mousemove'],
});
